import { render, staticRenderFns } from "./shopSaleStat.vue?vue&type=template&id=036ee2ac&"
import script from "./shopSaleStat.vue?vue&type=script&lang=js&"
export * from "./shopSaleStat.vue?vue&type=script&lang=js&"
import style0 from "./shopSaleStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports